
import { signInWithPopup, GoogleAuthProvider, getAuth } from "firebase/auth";
import { doc,setDoc, arrayUnion, getDoc } from "firebase/firestore";
import { Header } from "../Components/Header";
import { db } from '../Firebase';
import { useNavigate } from 'react-router-dom';


export const Login = () => {
    let navigate = useNavigate();
    async function GoogleSignIn(){
        const provider = new GoogleAuthProvider();
        const auth = getAuth();
        await signInWithPopup(auth, provider);
        const user = auth.currentUser
        console.log(user.uid)
        const userRef = doc(db,"users",user.uid);
        const docSnap = await getDoc(userRef);
        console.log("userref",userRef)
        if (docSnap.exists()) {
            console.log('あったよ')
            navigate("/login");
            console.log("ログイン済みですよ")
        }else{
            console.log('ないよお')
            await setDoc(doc(db,"users",user.uid),{
                        tops_img_file: arrayUnion(),
                        bottoms_img_file: arrayUnion(),
                        shoes_img_file: arrayUnion()
                    }).then(()=>{
                        console.log("登録成功です")
                        navigate("/login")
                    }).catch(err=>{
                        console.log("err:", err);
                        alert("登録失敗でしゅ");
                    })
        }

    }
    return(
        <div className="homepage">
            <Header/>
            <div className="body-login">
                <div className="login">
                    <div className="login-title"><p>SIGN IN</p></div>
                    <div className="login-button">
                        <button className="login-button-real" onClick={GoogleSignIn}>
                            <span>Hover me</span>
                            <svg viewBox="0 0 13 10" height="10px" width="15px">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}